import React from "react";;
import { Row } from "../atoms/ProjectCard";
import { ColumnFlexBox } from "../templates/Wrappers";
import { ProjectTable } from "../../shared/ProjectContent";


const ProjectContentTable: React.FC<{ table?: ProjectTable }> = ({ table }) => {
  if (!table) return <></>

  return <ColumnFlexBox>{table.map((row, key)=> Row((row[0] || '').toString(), (row[1] || '').toString(), key))}</ColumnFlexBox>
}

export default ProjectContentTable;
